import useSWR from "swr"

// Services
import { getProductsByPartNos } from "services/storm";

// Interfaces
import useAuth from "./useAuth";
import { ProductListItem } from "interfaces/Storm/Product";

const fetcher = async (_: string, partNos: string) => getProductsByPartNos(partNos).then((res) => res.data);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useProductsWithCustomerPrices = (products: ProductListItem[] | undefined) => {
    const { isLoggedIn } = useAuth();

    // Only check prices if user is logged in and there are product items
    const { data, error } = useSWR(isLoggedIn && products && products.length > 0 ? ['/api/products/getProductsByPartNos', products.map(product => product.partNo).toString()] : null, fetcher);

    const getProductsWithCustomerPrices = () => {
        if (!data) {
            return products;
        } else if (products) {
            return products.map(product => {
                const match = data.items.find((productWithCustomerPrice) => productWithCustomerPrice.partNo === product.partNo);
                if (match) {
                    product.price = match.price;
                }
                return product;
            })
        } else {
            return [];
        }
    }

    return {
        products: getProductsWithCustomerPrices(),
        error,
        pricesAreLoading: !data && !error,
    }
};

export default useProductsWithCustomerPrices;